import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Show-on outlined icon
 *
 * @file ShowOnOutlined.jsx
 * @author Sam George
 */
const ShowOnOutlined = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentcolor"
        d="M12,4 C17.3611929,4 21.9578009,7.30108581 23.8999996,11.9975519 C21.9578009,16.694018
        17.3611929,19.9951038 12,19.9951038 C6.63880713,19.9951038 2.04219905,16.694018 0.100000381,11.9975519
        C2.04219905,7.30108581 6.63880713,4 12,4 Z M12,6 C7.85280338,6 4.13574904,8.36373136
        2.2987767,11.9975519 C4.13574904,15.6313724 7.85280338,17.9951038 12,17.9951038 C16.1471966,17.9951038
        19.864251,15.6313724 21.7012233,11.9975519 C19.864251,8.36373136 16.1471966,6 12,6 Z M12,7
        C14.7614237,7 17,9.23857625 17,12 C17,14.7614237 14.7614237,17 12,17 C9.23857625,17 7,14.7614237
        7,12 C7,9.23857625 9.23857625,7 12,7 Z M12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542
        10.3431458,15 12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 Z"
      />
    </g>
  </SvgIcon>
);

export default ShowOnOutlined;
